// src/styles/kozelBattle/prefer.ts
import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const usePreferStyles = createUseStyles((theme: Theme) => {
    return {
        wrapper: {
            position: 'relative',
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px 40px',
            margin: '0 auto',
            marginTop: theme.spacing(4),
            borderRadius: '10px',
            maxWidth: '1000px',
            [theme.breakpoints.up('sm')]: {
                padding: '15px 50px',
            },
            [theme.breakpoints.up('md')]: {
                padding: '10px',
            },
        },
        content: {
            position: 'relative',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        title: {
            fontFamily: theme.fonts.poplar,
            color: theme.colors.espresso_brown,
            fontSize: '2rem',
            textAlign: 'center',
            textTransform: 'uppercase',
            marginBottom: theme.spacing(2),
            lineHeight: 1.2,
            [theme.breakpoints.up('sm')]: {
                fontSize: '3rem',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '3.5rem',
            },
        },
        subtitle: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.espresso_brown,
            fontSize: '0.85rem',
            textAlign: 'center',
            marginBottom: theme.spacing(2),
            maxWidth: '550px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '0.95rem',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '1rem',
            },
        },
        copiteRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: theme.spacing(1),
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(1),
        },
        copiteIcon: {
            width: '40px',
            height: 'auto',
            [theme.breakpoints.up('sm')]: {
                width: '50px',
            },
            [theme.breakpoints.up('md')]: {
                width: '60px',
            },
        },
        tapMicImage: {
            width: '80px',
            height: 'auto',
            marginTop: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
                width: '100px',
            },
            [theme.breakpoints.up('md')]: {
                width: '120px',
            },
        },
    };
});

export default usePreferStyles;